import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {CatalogModel} from '../../../../app/model/other-catalogs-models';
import {DataTableDirective} from 'angular-datatables';
import {Subject} from 'rxjs';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ToastrService} from 'ngx-toastr';
import {environment} from '../../../../environments/environment';
import {BaseFisofoService} from '../../../services/base-fisofo.service';
import {BaseFisofo} from '../../../model/base-fisofo';
import {ModalUploadBaseFisofoComponent} from '../../../shared/modal-upload-base-fisofo/modal-upload-base-fisofo.component';

@Component({
  selector: 'app-upload-base-fisofo',
  templateUrl: './upload-base-fisofo.component.html',
  styleUrls: ['./upload-base-fisofo.component.css']
})
export class UploadBaseFisofoComponent implements OnInit, AfterViewInit {

  public year:string="";
  public month:string="";

  // estado pagina
  public page='UploadBaseFisofo';
  public viewStatus:number=0;
  public loading:number=0;
  public initYear:number=null;
  public initMonth:number=null;
  public listMonths:CatalogModel[]=[];
  public listMonthsFiltered:CatalogModel[]=[];
  public listBaseFisofoFiltered:BaseFisofo[]=[];
  public selectedMonths:any[]=[];

  @ViewChild(DataTableDirective, {static: false})
  private datatableElement: DataTableDirective;
  private url:string;

  // opciones datatables
  dtTrigger: Subject<any> = new Subject();
  dtOptions: any = {};

  constructor(
    private baseFisofoService:BaseFisofoService,
    private modalService:NgbModal,
    private toastr:ToastrService
  ) {
    this.url=environment.services_url;
  }

  ngOnInit() {
    this.dtOptions={
      order:[],
      responsive: true,
      columnDefs: [
        { responsivePriority: 1, width:100, targets: -1 }
      ],
      select: 'single',
      bLengthChange: true,
      searching :true,
      dom:'<"row"<"col"l><"col"<"text-center"B>><"col"f>><"row"<"col"t>><"row"<"col"i><"col"p>>',
      buttons: [],
      //buttons: ['csv', 'excel'],
      // dom: 'Bfrtip',
      autoWidth:false,
      pagingType: 'full_numbers',
      retrieve: true,
      paging:true,
      pageLength: 25,
      processing: true,
      serverSide: true,
      ajax: {
        crossDomain: true,
        headers: {  'Access-Control-Allow-Origin': '*' },
        url: this.url + "/BaseFisofo/getListBaseFisofoPaginated",
        method: "POST",
        data: function ( data ) {
          //process data before sent to server.
          data.year=$('#year-input').val();
          data.month=$('#month-input').val();
          return JSON.stringify(data);
        }
      },
      columns : [{
        data : 'year',
        className: 'text-center'
      }, {
        data : 'month',
        className: 'text-center'
      }, {
        data : 'region',
        className: 'text-center'
      }, {
        data : 'branch',
        className: 'text-center'
      }, {
        data : 'supervisorId',
        className: 'text-center'
      }, {
        data : 'supervisorName',
        className: 'text-center'
      }, {
        data : 'managerId',
        className: 'text-center'
      }, {
        data : 'managerName',
        className: 'text-center'
      }, {
        data : 'adviserId',
        className: 'text-center'
      }, {
        data : 'adviserName',
        className: 'text-center'
      }, {
        data : 'folio',
        className: 'text-center'
      }, {
        data : 'clientName',
        className: 'text-center'
      }, {
        data : 'afiliateName',
        className: 'text-center'
      }, {
        data : 'collectAmount',
        className: 'text-center'
      }, {
        data : 'paymentTerm',
        className: 'text-center'
      }, {
        data : 'commission',
        className: 'text-center'
      }, {
        data : 'commissionAmount',
        className: 'text-center'
      }, {
        data : 'rateMin',
        className: 'text-center'
      }, {
        data : 'rateMax',
        className: 'text-center'
      }, {
        data : 'advanceMin',
        className: 'text-center'
      }, {
        data : 'advanceMax',
        className: 'text-center'
      }, {
        data : 'createDate',
        className: 'text-center'
      }, {
        data : 'activeId',
        className: 'text-center'
      }],
      drawCallback: function (settings) {
        // Here the response
        var response = settings.json;
        this.listBaseFisofoFiltered=response.data;
        console.log(">> this.listBaseFisofoFiltered=", this.listBaseFisofoFiltered);
      },
      language: {
        processing: 'Procesando...',
        search: 'Buscar:',
        lengthMenu: 'Mostrar _MENU_ elementos',
        info: 'Mostrando del _START_ al _END_ de _TOTAL_ elementos',
        infoEmpty: 'Mostrando ningún elemento.',
        infoFiltered: '(filtrado _MAX_ elementos total)',
        infoPostFix: '',
        loadingRecords: 'Cargando registros...',
        zeroRecords: 'No se encontraron registros',
        emptyTable: 'No hay datos disponibles en la tabla',
        paginate: {
          first: 'Primero',
          previous: 'Anterior',
          next: 'Siguiente',
          last: 'Último'
        },
        aria: {
          sortAscending: ': Activar para ordenar la tabla en orden ascendente',
          sortDescending: ': Activar para ordenar la tabla en orden descendente'
        }//,
        // dom: 'Bfrtip',
        // buttons: [
        //   'excel'
        // ]
      }
    };

    this.viewStatus = 1;

    var currentTime = new Date()
    var currentMonth = currentTime.getMonth() + 1
    var currentYear = currentTime.getFullYear();
    var currentDay = currentTime.getDate();

    if(currentMonth === 1){ //Enero
      this.initMonth = 12;
      this.initYear = currentYear - 1;
    }else{
      this.initMonth = currentMonth - 1;
      this.initYear = currentYear;
    }

    let startDate = this.initYear + "-" + (this.initMonth<10 ? "0"+this.initMonth : this.initMonth) + "-01";
    let endDate =  currentYear + "-" + (currentMonth<10 ? "0"+currentMonth : currentMonth) + "-01";

    this.generateMonthsRange(startDate, endDate);
  }
  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  // EVENTS
  onMonthChange=(e: any[])=>{
    this.selectedMonths = e;
    console.log(">> this.selectedMonth= ", this.selectedMonths[0]);
    if(this.selectedMonths != null && this.selectedMonths.length > 0){
      let yearMonth:string[] = this.selectedMonths[0].description.split(" ");
      this.month = yearMonth[0];
      this.year = yearMonth[1];
    }else{
      this.month = "";
      this.year = "";
    }
  }
  onUploadBaseFisofo=()=>{
    if(this.selectedMonths != null && this.selectedMonths.length > 0){
      let yearMonth:string[] = this.selectedMonths[0].description.split(" ");
      let month:string = yearMonth[0];
      let year:string = yearMonth[1];
      let modalRef=this.modalService.open(ModalUploadBaseFisofoComponent, {centered:true, size:'lg', scrollable:true, backdrop:'static', keyboard:false});
      modalRef.componentInstance.title='<i class="icon-upload"></i>&nbsp;&nbsp;Carga base de refinanciamiento';
      modalRef.componentInstance.page=this.page;
      modalRef.componentInstance.mode='upload';
      modalRef.componentInstance.year=year;
      modalRef.componentInstance.month=month;
      modalRef.result.then(
        data=> console.log(data),
        reason=> {
          console.log(">> reason=", reason);
          if(reason==="success"){
            this.onViewBaseFisofo();
          }
        }
      );
    }else{
      this.toastr.error('Seleccione un mes!');
    }
  }
  onDownloadBaseFisofo=()=>{
    if(this.month != "" && this.year != "") {
      this.baseFisofoService.download(this.year, this.month).subscribe(response => {
        this.downloadFile(response, this.year, this.month);
      });
    } else {
      this.toastr.error('Seleccione un mes!');
    }
  }
  onViewBaseFisofo=()=> {
    if(this.month != "" && this.year != ""){
      this.rerender();
    } else {
      this.toastr.error('Seleccione un mes!');
    }
  }

  // HELPERS
  generateMonthsRange(startDate: string, endDate: string) {
    var start      = startDate.split('-');
    var end        = endDate.split('-');
    var startYear  = parseInt(start[0]);
    var endYear    = parseInt(end[0]);

    for(var i = startYear; i <= endYear; i++) {
      var endMonth = i != endYear ? 11 : parseInt(end[1]) - 1;
      var startMon = i === startYear ? parseInt(start[1])-1 : 0;
      for(var j = startMon; j <= endMonth; j = j > 12 ? j % 12 || 11 : j+1) {
        var month = j+1;
        var displayMonth = month < 10 ? '0'+month : month;
        switch (month) {
          case 1:
            displayMonth="ENERO";
            break;
          case 2:
            displayMonth="FEBRERO";
            break;
          case 3:
            displayMonth="MARZO";
            break;
          case 4:
            displayMonth="ABRIL";
            break;
          case 5:
            displayMonth="MAYO";
            break;
          case 6:
            displayMonth="JUNIO";
            break;
          case 7:
            displayMonth="JULIO";
            break;
          case 8:
            displayMonth="AGOSTO";
            break;
          case 9:
            displayMonth="SEPTIEMBRE";
            break;
          case 10:
            displayMonth="OCTUBRE";
            break;
          case 11:
            displayMonth="NOVIEMBRE";
            break;
          case 12:
            displayMonth="DICIEMBRE";
            break;
          default:
            console.log("No such day exists!");
            break;
        }
        let option1 = new CatalogModel();
        option1.id = month;
        option1.description = displayMonth + " " + i;

        this.listMonthsFiltered.push(option1);
      }
    }
    //console.log(">> this.listMonthsFiltered= ", this.listMonthsFiltered);
  }
  rerender(): void {
    this.datatableElement.dtInstance.then((dtInstance) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }
  downloadFile(data: Blob, year:string, month:string) {
    const contentType = 'application/vnd.openxmlformats-ficedocument.spreadsheetml.sheet';
    const blob = new Blob([data], { type: contentType });
    const fileName:string = 'BASE_FISOFO_' + year + '_' + month + '.xlsx';
    const objectUrl:string = URL.createObjectURL(blob);
    const a:HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;

    a.href = objectUrl;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
    URL.revokeObjectURL(objectUrl);
  }

}
